import React, { Component } from 'react'
import {injectStripe} from 'react-stripe-elements'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import ErrorMessage2UI from '../../../widgets/form/ErrorMessage2UI'
import SuccessMessageUI from '../../../widgets/form/SuccessMessageUI'
import CreditCard from '../../../widgets/input/CreditCard'
import './CreditCardForm.css'

// https://stripe.com/docs/recipes/elements-react
class CreditCardForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      successMsg: null,
      submitted: false,
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  render() {
    return (
      <div className="acc_cc_f">
        <SuccessMessageUI successMsg={this.state.successMsg} />
        <ErrorMessage2UI errorList={this.state.errorList} />
        <CreditCard context={this.props.context} />
        <div className='action g_flex_h'>
          <ButtonUI
            messageList={this.props.messageList}
            labelKey='c_cancel'
            transparent={true}
            onClick={this.props.onCancelCreateOrUpdateClick} />
          <SpinnerUI show={this.state.submitted} />
          <ButtonUI
            messageList={this.props.messageList}
            labelKey={this.props.updateMode ? 'c_update_card' : 'c_add_card'}
            onClick={this.onSubmit}
            disabled={this.state.submitted}
          />
        </div>
      </div>
    )
  }

  async onSubmit(ev) {
    let token = await this.props.stripe.createToken({name: "Name"})
    console.log(token)

    if (token.error) {
      // e.g.:
      // type: "validation_error", code: "incomplete_number", message: "Your card number is incomplete."
      // type: "validation_error", code: "invalid_number", message: "Your card number is invalid."
      // TODO localize
      let errorList = [token.error]
      this.setState({errorList: errorList})
      return
    }

    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: null,
      submitted: true
    })
    RestApiUtils.put(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/paymentMethods/first`,
      this.onSubmitCallback, {
        stripeToken: token.token.id,
      }
    )
  }

  onSubmitCallback = (response) => {
    this.setState({
      successMsg: response.success,
      errorList: response.errorList,
      submitted: false
    })
    this.props.onPaymentSettingsChange()
    setTimeout(() => {
      this.props.onCancelCreateOrUpdateClick()
    }, 2000)
  }
}

export default injectStripe(CreditCardForm)
